import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const PopOutIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M15 4a1 1 0 1 1 0-2h6c.6 0 1 .4 1 1v6a1 1 0 1 1-2 0V5.4l-9.3 9.3a1 1 0 0 1-1.4-1.4L18.6 4H15Z" />
    <path d="M5 7a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6a1 1 0 1 1 2 0v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h6a1 1 0 1 1 0 2H5Z" />
  </Icon>
));
export default PopOutIcon;
